import { Icon } from "@omnabase/ui";
import { publicOrigin } from "@omnabase/shared";
import { useSession } from "../../shell/store";
import { useNav, useWs } from "../../lib/nav";
import type { Scope } from "../../lib/knowledge";

/** The articles page head's addition of the knowledge collections round (the founder, 2026-10-12: "a link for easy access to the knowledge
 *  base from the articles page"): the help-centre link. (A collection's own menu went to the collections screen the same day.) */

/** "Open the help centre" (a new tab, the workspace's own host) while the project's help centre is on, else "Set up the help centre" (its
 *  settings tab); Shared has no help centre of its own and shows neither */
export function HelpCentreLink({ scope }: { scope: Scope }) {
  const nav = useNav(); const { ws } = useWs(); const { workspace } = useSession();
  const project = scope.shared ? undefined : workspace.projects.find((p) => p.id === scope.id);
  if (!project) return null;
  if ((project.helpCentre as { enabled?: boolean } | undefined)?.enabled) {
    const href = `${publicOrigin(window.location.origin, workspace.slug)}/help/${project.slug}`;
    return <a className="ob-btn ob-btn--ghost ob-btn--sm" href={href} target="_blank" rel="noopener noreferrer"><Icon name="openInNew" size="sm" />Open the help centre</a>;
  }
  const setup = ws(`/settings/projects/${project.id}?tab=help`);
  return <a className="ob-btn ob-btn--ghost ob-btn--sm" href={setup} onClick={(e) => nav(setup, e)}><Icon name="settings" size="sm" />Set up the help centre</a>;
}
